import React from "react";
import { Busy } from "../presentational/busy";
import { SelectedCharities } from "../presentational/selectedCharities";
import { Card } from "../presentational/card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/pro-light-svg-icons/faArrowCircleLeft";
import ReactGA from "react-ga";
import styles from "../../styles/panels/charityDetails.css";
import * as utilities from "../../middleware/utilities";

export class CharityDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      busy: false,
      charity: this.props.tempCharity,
    };
  }
  componentDidMount() {
    ReactGA.pageview("/Spend/CharityDetails");
    utilities
      .isCodeValid(this.props.code)
      .then((valid) => {
        if (!valid) {
          this.props.onCodeError();
        }
        this.getCharity();
      })
      .catch(() => {
        this.props.onCodeError();
      });
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.selectedCategory &&
      (prevProps.selectedCategory.id != this.props.selectedCategory.id ||
        prevProps.selectedCharityID != this.props.selectedCharityID)
    ) {
      this.getCharity();
    }
  }
  getCharity() {
    if (this.props.selectedCategory) {
      this.setState({ busy: true }, () => {
        utilities
          .getFeaturedCharities(this.props.selectedCategory.id)
          .then((featuredCharities) => {
            this.setState({
              busy: false,
              charity: featuredCharities.charities.find((charity) => {
                return charity.ein == this.props.selectedCharityID;
              }),
            });
          });
      });
    } else {
      this.setState({ busy: true }, () => {
        utilities
          .getNationalCharities({
            query: this.props.selectedCharityID,
            postalCode: "",
            columnName: "",
            continuationToken: null,
          })
          .then((nationalCharities) => {
            this.setState({
              busy: false,
              charity: nationalCharities.charities.find((charity) => {
                return charity.ein == this.props.selectedCharityID;
              }),
            });
          });
      });
    }
  }
  renderNavigation() {
    return (
      <div className={styles.navigation}>
        <div className={styles.message}>
          <div
            className={styles.icon}
            onClick={() => {
              ReactGA.event({
                category: "User Action",
                action: "Clicked Back Button",
                label: "/Spend/CharityDetails",
              });
              this.props.onBack();
            }}
          >
            <FontAwesomeIcon icon={faArrowCircleLeft} />
          </div>
          {this.state.charity.name}
        </div>
      </div>
    );
  }
  renderAside() {
    return (
      <div className={styles.aside}>
        <SelectedCharities
          selectedCharities={this.props.selectedCharities}
          dictionary={this.props.dictionary}
          additionalCharityCount={this.props.additionalCharityCount}
          collapse={this.props.collapseSelectedCharities}
          donation={this.props.donation}
          onToggleCollapse={() => {
            this.props.onToggleCollapseSelectedCharities();
          }}
          onRemoveCharity={(ein) => {
            this.props.onRemoveCharity(ein);
          }}
          onContinue={() => {
            this.props.onContinue();
          }}
        />
        <Card
          src={this.props.donation.image}
          alt={this.props.donation.amount}
        />
      </div>
    );
  }
  render() {
    if (this.props.busy || this.state.busy) {
      return <Busy />;
    } else {
      if (this.state.charity) {
        let selectedEINs = this.props.selectedCharities.map((charity) => {
          return charity.ein;
        });
        return (
          <div className={styles.main}>
            {this.renderNavigation()}
            <div className={styles.content}>
              <div className={styles.charity}>
                <img
                  src={this.state.charity.image}
                  title={this.state.charity.title}
                  className={styles.image}
                />
                <div className={styles.label}>
                  {this.state.charity.description}
                </div>
                <div className={styles.commands}>
                  {selectedEINs.indexOf(this.state.charity.ein) == -1 ? (
                    this.props.additionalCharityCount >=
                    this.props.selectedCharities.length ? (
                      <button
                        className={styles.button + " " + styles.select}
                        onClick={(event) => {
                          event.stopPropagation();
                          ReactGA.event({
                            category: "User Action",
                            action: "Clicked Select Charity",
                            label: "/Spend/CharityDetails",
                          });
                          this.props.onSelectCharity(this.state.charity);
                        }}
                      >
                        {this.props.dictionary.featured_charity_selector_select}
                      </button>
                    ) : (
                      <button className={styles.button + " " + styles.disabled}>
                        {
                          this.props.dictionary
                            .featured_charity_selector_disabled
                        }
                      </button>
                    )
                  ) : (
                    <button
                      className={styles.button + " " + styles.unselect}
                      onClick={(event) => {
                        event.stopPropagation();
                        ReactGA.event({
                          category: "User Action",
                          action: "Clicked Remove Charity",
                          label: "/Spend/CharityDetails",
                        });
                        this.props.onRemoveCharity(this.state.charity.ein);
                      }}
                    >
                      {this.props.dictionary.featured_charity_selector_unselect}
                    </button>
                  )}
                </div>
              </div>
            </div>
            {this.renderAside()}
          </div>
        );
      } else {
        return null;
      }
    }
  }
}
